import { combineReducers } from 'redux';
import { AuthenticationReducer } from "./AuthenticationReducer";
import { WelcomeReducer } from "./WelcomeReducer";
import { ActivityIndicatorReducer } from "./ActivityIndicatorReducer";
import { DomainReducer } from "./DomainReducer";
import { CountryReducer } from "./CountryReducer";
import { UsersReducer } from "./UsersReducer";
import { CategoryReducer } from "./CategoryReducer";
import { GamesReducer } from "./GamesReducer";
import { SplashScreenReducer } from "./SplashScreenReducer";
import { HeaderReducer } from './HeaderReducer';
import { AccountReducer } from './AccountReducer';
import { FlashMessageReducer } from './FlashMessageReducer';
import { SearchReducer } from './SearchReducer';

export default combineReducers({
    AuthenticationReducer,
    WelcomeReducer,
    ActivityIndicatorReducer,
    DomainReducer,
    CountryReducer,
    UsersReducer,
    CategoryReducer,
    GamesReducer,
    SplashScreenReducer,
    HeaderReducer,
    AccountReducer,
    FlashMessageReducer,
    SearchReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js